import React from 'react';
import 'tailwindcss/tailwind.css';

const Overons = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="bg-white shadow-lg rounded-lg p-8 mb-8">
          <div className="flex flex-col items-start gap-2">
            <p className="text-lg text-gray-600 leading-relaxed">
              Welkom bij Autotheker, waar onze liefde voor auto's de drijvende kracht is achter ons succes. Als een klein, toegewijd autobedrijf zijn we ontstaan uit pure passie voor alles wat met auto's te maken heeft.
            </p>
            <p className="text-lg text-gray-600 leading-relaxed">
              <b>Onze Missie</b>
            </p>
            <p className="text-lg text-gray-600 leading-relaxed">
              Bij Autotheker geloven we in het leveren van uitstekende service en het creëren van een persoonlijke ervaring voor elke klant. Wij streven ernaar om niet alleen een voertuig te verkopen, maar ook een glimlach op uw gezicht te toveren. Wij staan altijd klaar om u met open armen te ontvangen en u te begeleiden in uw zoektocht naar de perfecte auto.
            </p>
            <p className="text-lg text-gray-600 leading-relaxed">
              <b>Specialisatie</b>
            </p>
            <p className="text-lg text-gray-600 leading-relaxed">
              Wij zijn gespecialiseerd in het aanbieden van betaalbare auto's. We begrijpen dat de aanschaf van een auto een lastige keuze kan zijn, en daarom richten we ons op het leveren van kwaliteitsvoertuigen die binnen een breed scala van budgetten passen. Of u nu op zoek bent naar een betrouwbare gezinsauto of een eerste auto voor een nieuwe bestuurder, wij helpen u met de zoektocht naar de auto die bij u past.
            </p>
            <p className="text-lg text-gray-600 leading-relaxed">
              <b>Exclusiviteit</b>
            </p>
            <p className="text-lg text-gray-600 leading-relaxed">
              Naast onze betaalbare opties, proberen we ook af en toe iets unieks en exclusiefs aan te bieden. Of het nu gaat om een zeldzame klassieker of een bijzondere, sportieve bolide, we zijn altijd op zoek naar dat ene speciale voertuig dat net dat beetje extra biedt. Deze exclusieve auto's zijn zorgvuldig geselecteerd om ervoor te zorgen dat ze voldoen aan onze hoge normen van kwaliteit en stijl.
            </p>
            <p className="text-lg text-gray-600 leading-relaxed">
              Bij Autotheker is uw tevredenheid onze prioriteit. We kijken ernaar uit om u te verwelkomen in ons bedrijf en u te helpen de auto van uw dromen te vinden. Kom langs en ervaar zelf waarom Autotheker de perfecte keuze is voor uw volgende auto-aankoop.
            </p>
          </div>
        </div>
      </div>
      <div className="mt-12 text-center">
        <div className="inline-block bg-blue-500 hover:bg-blue-600 text-white font-semibold py-3 px-8 rounded-lg transition duration-300">
          <a href="/contact" className="text-lg text-white no-underline"> 
            Neem Contact Op
          </a>
        </div>
      </div>
    </div>
  );
};

export default Overons;